import { computed, Injectable, signal } from '@angular/core';
import { CalculateRoutesRootDto } from '../../models/tourPointTypes';
import { environment } from 'apps/nagel-cal-disposition/environment/environment';
import { transportOrderResourceEndpoint } from '../configuration/consts/endpoints';
import { protectSubscription } from '@nagel-utils';
import { RequestService } from '@nagel-services';
import { BehaviorSubject, debounceTime, filter } from 'rxjs';

const CALCULATE_ROUTES_DEBOUNCE_TIME = 3000;

//TODO: Uncomment when calculate routes returns dto
@Injectable({
    providedIn: 'root',
})
export class CalculateRoutesService {
    isCalculatingTourPoints = signal<boolean>(false);
    isCalculateDisabled = signal<boolean>(true);
    hasValidationErrors = signal<boolean>(false);
    isFixedTimeForFirstTourPoint = signal<boolean>(false);

    shouldDisableCalculate = computed(() => {
        return this.isCalculateDisabled()
            || this.isCalculatingTourPoints()
            || this.hasValidationErrors()
            || this.isFixedTimeForFirstTourPoint();
    });

    isCalculatingRoutesSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    isCalculatingRoutesObservable$ = this.isCalculatingRoutesSubject.asObservable();

    triggerSilentCalculateRoutesSubject: BehaviorSubject<number | null> = new BehaviorSubject<number | null>(null);
    triggerSilentCalculateRoutesObservable$ = this.triggerSilentCalculateRoutesSubject.asObservable();

    constructor(
        private requestService: RequestService,
        // private snackbarService: SnackbarService
    ) {
        this.triggerSilentCalculateRoutesObservable$
            .pipe(
                filter((id: number | null) => id !== null),
                debounceTime(CALCULATE_ROUTES_DEBOUNCE_TIME),
            )
            .subscribe((transportOrderId: number) => {
                this.calculateRoutes(
                    transportOrderId,
                    undefined,
                    undefined,
                    true
                );
            });
    }

    calculateRoutes = (
        transportOrderId: number | null,
        onSuccess?: (isCalculatingRoutesSubject: BehaviorSubject<boolean>) => void,
        onError?: (isCalculatingRoutesSubject: BehaviorSubject<boolean>) => void,
        isSilent: boolean = false,
    ) => {
        const requestUrl = `${environment.apiUrl}${transportOrderResourceEndpoint}/${transportOrderId}/calculate-routes`;

        if (!isSilent) {
            this.isCalculatingRoutesSubject.next(true);
        }

        protectSubscription(
            this.requestService.postRequest<Date, CalculateRoutesRootDto>(
                requestUrl,
            ),
            () => {
                // const { setXserverDtoResponse } = response;

                // if (setXserverDtoResponse.isSuccessful) {
                //     onSuccess && onSuccess(response);
                // } else {
                //     this.snackbarService.pushSnackbar({
                //         message: $localize`Calculate routes failed: ${setXserverDtoResponse.responseText}`,
                //         action: $localize`Close`,
                //         type: ERROR_SNACKBAR
                //     });
                // }

                onSuccess && onSuccess(this.isCalculatingRoutesSubject);
            },
            (error) => {
                console.error(error);

                onError && onError(this.isCalculatingRoutesSubject);
            },
            true
        );
    };
}